import * as React from "react";
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import { connect } from "react-redux";
import * as d from "../../reducers/domainReducer";
import * as types from "../../constants/actionTypes";
import PharmacyInfo from "./PharmacyInfo";
import ActionTile from "./ActionTile";
import ReadyForPickup from "./ReadyForPickup";
import ReadyForRefill from "./ReadyForRefill";
import PharmacyHeader from "./PharmacyHeader";
import NotAuthorized from "../common/NotAuthorized";
import SectionLoading from '../common/SectionLoading';
import SectionLoadingError from '../common/SectionLoadingError';
import DataComponent from "../common/DataComponent";
import { logUI } from "../../api/andyliticsApi";
import * as Tools from "../../helpers/Tools";
import * as msgs from "../../constants/textConstants";

/**
 * Container component for the pharmacy page.
 * 
 */
class Pharmacy extends React.Component { //DataComponent {
    constructor(props) {
        super(props);
        this.toggle = this.toggle.bind(this);
        //this.loadData = this.loadData.bind(this);
        //this.shouldLoadData = this.shouldLoadData.bind(this);
        this.state = { activeTab: '1' };
        this.patientId = null;
    }

    componentDidMount() {
        this.props.getData();
        logUI("MBHWeb.UI.Rx.Pharmacy.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    componentDidUpdate() {
        const { rxDown, hasPharmacyLogin, currentPharmacyUser, pharmacyDashboardLoaded, defaultPharmacyLoaded, getData, defaultPharmacy, defaultPharmacyStoreNumber } = this.props;
        const patientId = currentPharmacyUser ? currentPharmacyUser.pharmacyPatientId : null;

        if (patientId && patientId !== this.patientId) {
            this.patientId = patientId;
            getData();
        } else if (!rxDown && hasPharmacyLogin && !patientId && this.patientId !== -1) {
            this.patientId = -1;
            getData();
        } else if (this.pharmacySelected && this.pharmacySelected.StoreNumber === defaultPharmacyStoreNumber) {
            this.pharmacySelected = null;
            getData();
        }

        //if (hasPharmacyLogin && (!pharmacyDashboardLoaded || !defaultPharmacyLoaded ||
        //    (defaultPharmacyStoreNumber && defaultPharmacyStoreNumber !== defaultPharmacy.StoreNumber))) {
        //    getData();
        //}
    }

    //shouldLoadData() {
    //    const { hasPharmacyLogin, pharmacyDashboardLoaded, defaultPharmacyLoaded, getData, defaultPharmacy, defaultPharmacyStoreNumber } = this.props;
    //    return hasPharmacyLogin && (!pharmacyDashboardLoaded || !defaultPharmacyLoaded ||
    //        (defaultPharmacyStoreNumber && defaultPharmacyStoreNumber !== defaultPharmacy.StoreNumber));
    //}

    //loadData() {
    //    this.props.getData();
    //}

    toggle(tab) {
        if (this.state.activeTab !== tab) {
            this.setState({ activeTab: tab });
        }
    }

    onPharmacySelected(pharmacy) {
        this.pharmacySelected = pharmacy;
    }

    render() {
        if (typeof window === 'undefined') {
            return null;
        }

        const {
            isLinkDialogOpen, rxDown, hasPharmacyLogin, currentPharmacyUser, defaultPharmacy, waitingOnPharmacy, pharmacyDetails, pharmacyServiceError,
            readyForPickup, waitingOnReadyForPickup, readyForPickupError, readyForRefill, waitingOnReadyForRefill, readyForRefillError,
            screenBreakPoint
        } = this.props;

        return (
            <React.Fragment>
                {!isLinkDialogOpen && (hasPharmacyLogin || (currentPharmacyUser && currentPharmacyUser.pharmacyPatientId))
                    ? <div className="container-fluid body-content pharmacy-home-container">
                        <div className="row">
                            <div className="col-12 maxWidth-content">
                                <div className="row">
                                    <PharmacyHeader />
                                    <div className="col-12">
                                        {typeof waitingOnPharmacy === 'undefined' || waitingOnPharmacy
                                            ? <SectionLoading />
                                            : !pharmacyServiceError
                                                ? defaultPharmacy && <PharmacyInfo title="Your Pharmacy" pharmacy={defaultPharmacy} onChange={(pharmacy) => this.onPharmacySelected(pharmacy)} />
                                                : <SectionLoadingError message={pharmacyServiceError.status && pharmacyServiceError.status >= 400
                                                    ? "We're sorry, there was an error while loading your pharmacy information. Please try again later."
                                                    : "No default pharmacy available."
                                                } />
                                        }
                                        <div className="row button-row">
                                            <ActionTile title="Order a Refill" containerClass="col-6 col-lg-3" iconClass="icon-refill" path="rxRefill" />
                                            <ActionTile title="Transfer" containerClass="col-6 col-lg-3" iconClass="icon-transfer" path="rxTransfer" />
                                            <ActionTile title="View Prescriptions" containerClass="col-6 col-lg-3" iconClass="icon-view-prescriptions" path="rxList" />
                                            <ActionTile title="Find a Pharmacy" containerClass="col-6 col-lg-3" iconClass="icon-find-pharmacy" path="findPharmacy" />
                                        </div>
                                        <Nav tabs>
                                            <NavItem>
                                                <NavLink className={this.state.activeTab === '1' ? 'tab-selected' : ''} onClick={() => this.toggle('1')}>
                                                    READY FOR PICK UP <div className="rx-count">{!waitingOnReadyForPickup && pharmacyDetails ? '(' + pharmacyDetails.ReadyForPickUpCount + ')' : '(0)'}</div>
                                                </NavLink>
                                            </NavItem>
                                            <NavItem>
                                                <NavLink className={this.state.activeTab === '2' ? 'tab-selected' : ''} onClick={() => this.toggle('2')}>
                                                    READY FOR REFILL <div className="rx-count">{!waitingOnReadyForRefill && pharmacyDetails ? '(' + pharmacyDetails.RxRefillCount + ')' : '(0)'}</div>
                                                </NavLink>
                                            </NavItem>
                                        </Nav>
                                        <TabContent activeTab={this.state.activeTab}>
                                            <TabPane tabId="1">
                                                {typeof waitingOnReadyForPickup === 'undefined' || waitingOnReadyForPickup
                                                    ? <SectionLoading />
                                                    : !readyForPickupError && !pharmacyServiceError
                                                        ? <div className="row"><ReadyForPickup readyForPickup={readyForPickup} defaultStoreNumber={defaultPharmacy ? defaultPharmacy.StoreNumber : null} /></div>
                                                        : <SectionLoadingError message="We're not able to display prescriptions ready for pick up. Please try again later." />
                                                }
                                            </TabPane>
                                            <TabPane tabId="2">
                                                {typeof waitingOnReadyForRefill === 'undefined' || waitingOnReadyForRefill
                                                    ? <SectionLoading />
                                                    : !readyForRefillError && !pharmacyServiceError
                                                        ? <div className="row"><ReadyForRefill readyForRefill={readyForRefill} defaultStoreNumber={defaultPharmacy ? defaultPharmacy.StoreNumber : null} /></div>
                                                        : <SectionLoadingError message="We're not able to display prescriptions ready for refill. Please try again later." />
                                                }
                                            </TabPane>
                                        </TabContent>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    : typeof hasPharmacyLogin !== 'undefined' && <NotAuthorized />
                }
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => {

    return {
        rxDown: state.common.rxDown,
        hasPharmacyLogin: state.memberships.isActiveFeature_Pharmacy,
        currentPharmacyUser: d.hydratePharmacyUser(state.domain.cpu),
        waitingOnPharmacy: state.pharmacy.waitingOnPharmacy,
        pharmacyServiceError: state.pharmacy.pharmacyError,
        defaultPharmacy: state.pharmacy.defaultPharmacy,
        defaultPharmacyStoreNumber: state.pharmacy.defaultPharmacyStoreNumber,
        pharmacyDetails: state.pharmacy.pharmacyDashboardDetails,
        isLinkDialogOpen: state.pharmacy.isLinkDialogOpen,
        readyForPickup: state.pharmacy.readyForPickup,
        waitingOnReadyForPickup: state.pharmacy.waitingOnReadyForPickup,
        readyForPickupError: state.pharmacy.readyForPickupError,
        readyForRefill: state.pharmacy.readyForRefill,
        waitingOnReadyForRefill: state.pharmacy.waitingOnReadyForRefill,
        readyForRefillError: state.pharmacy.readyForRefillError,
        pharmacyDashboardLoaded: state.pharmacy.pharmacyDashboardLoaded,
        defaultPharmacyLoaded: state.pharmacy.defaultPharmacyLoaded,
        screenBreakPoint: state.common.screenBreakPoint,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getData: () => dispatch({ type: types.LOAD_PHARMACYDASHBOARD_START, loadPickups: true, loadRefills: true })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Pharmacy);